<div class="pop-bg" [style.display]="showNotification ? 'block' : 'none'">

</div>

<div id="LogoutModal" style="top: 0;" class="modal" (click)="hidePopup()"
  [style.display]="showNotification ? 'block' : 'none'">

  <div class="modal-dialog modal-sm" style="max-width: 363px;" [ngStyle]="isFollowUp ? {'max-width': '463px', 'height': '21%'} : {}">

    <div class="modal-content" [ngStyle]="{'height': isFollowUp ? '70%': ''}">

      <div class="modal-body">

        <div class="" style="display: flex;">

          <img src="assets/images/warning.jpg" alt="exclamation" style="height: 20px;width: 30px;" />
          <span style="font-size: 14px;" [innerHTML]="successMessage[0]?.Message ? setMessage(successMessage[0]?.Message) : setMessage(successMessage)">
          </span>
        </div>

      </div>

      <div class="modal-footer1" *ngIf="!isFollowUp && !isActionSubmit">

        <button type="button" class="btn btn-default okBtn" (click)="closeModalFun()">Ok</button>

      </div>

      <!-- For Follow Up Button-->
      <div class="modal-footer1" *ngIf="isFollowUp" style="padding: 5px 15px;">
        <button type="button" class="btn btn-default okBtn" (click)="followUpSubmit(false)"
        [ngStyle]="{'width': isFollowUp ? 'auto' : ''}">Scenario Questionnaire</button>
        <button type="button" class="btn btn-default okBtn" (click)="followUpSubmit(true)"
        [ngStyle]="{'width': isFollowUp ? 'auto' : ''}">Concluded Inbox</button>

      </div>

      <div class="modal-footer1" *ngIf="isActionSubmit" style="padding: 5px 15px;">
        <button type="button" class="btn btn-default okBtn" (click)="actionSubmitModal(true)"
        [ngStyle]="{'width': isActionSubmit ? 'auto' : ''}">Yes</button>
        <button type="button" class="btn btn-default okBtn" (click)="actionSubmitModal(false)"
        [ngStyle]="{'width': isActionSubmit ? 'auto' : ''}">No</button>

      </div>

    </div>

  </div>

</div>
